export default "__VITE_ASSET__E4zxZOqG__"